export const STORE_RETREATS = "STORE_RETREATS";
export const STORE_TEACHERS = "STORE_TEACHERS";
export const STORE_LOCATIONS = "STORE_LOCATIONS";
export const STORE_FEES = "STORE_FEES";

// Auth actions
export const LOGGED_IN_STATUS_CHANGED = "LOGGED_IN_STATUS_CHANGED";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";
export const LOGIN_USER = "LOGIN_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
export const REGISTER_USER = "REGISTER_USER";
export const AUTH_FORM_UPDATE = "AUTH_FORM_UPDATE";
export const IDENTITY_UPDATED = "IDENTITY_UPDATED";
export const LOGOUT = "LOGOUT";

// User actions
export const NEW_USER = "NEW_USER";
export const FETCHING_USER = "FETCHING_USER";

// Chat actions
export const MESSAGE_TO_SEND_CHANGED = "MESSAGE_TO_SEND_CHANGED";
export const ADD_SUBSCRIBED_TOPIC = "ADD_SUBSCRIBED_TOPIC";
export const CLEAR_SUBSCRIBED_TOPICS = "CLEAR_SUBSCRIBED_TOPICS";
export const FETCHING_CHATS = "FETCHING_CHATS";
export const RECEIVE_CHATS = "RECEIVE_CHATS";
export const CREATING_CHAT = "CREATING_CHAT";
export const ADD_CHAT = "ADD_CHAT";
export const CHAT_ERROR = "CHAT_ERROR";
export const RESET_UNREADS = "RESET_UNREADS";

// IoT actions
export const CONNECT_POLICY_ATTACHED = "CONNECT_POLICY_ATTACHED";
export const PUBLIC_PUBLISH_POLICY_ATTACHED = "PUBLIC_PUBLISH_POLICY_ATTACHED";
export const PUBLIC_RECEIVE_POLICY_ATTACHED = "PUBLIC_RECEIVE_POLICY_ATTACHED";
export const PUBLIC_SUBSCRIBE_POLICY_ATTACHED =
  "PUBLIC_SUBSCRIBE_POLICY_ATTACHED";
export const DEVICE_CONNECTED_STATUS_CHANGED =
  "DEVICE_CONNECTED_STATUS_CHANGED";
export const MESSAGE_HANDLER_ATTACHED = "MESSAGE_HANDLER_ATTACHED";
